<template>
<v-container fluid v-if="this.archivoCSV">
    
    <v-card outlined>
    <v-toolbar dense flat>
        <div class="text-h6">Ligas de drive</div>
    </v-toolbar>
    <v-card-title>
        <v-card-subtitle>Correos y ligas de drive designadas para hacer envio del citatorio.</v-card-subtitle>

        <v-spacer></v-spacer>
        <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Buscar"
        single-line
        hide-details
        ></v-text-field>
    </v-card-title>
    <v-card-text>
    <v-data-table
        
    :headers="headers"
    :items="items"
    :search="search"
    :items-per-page="10"
    :footer-props="{
        itemsPerPageOptions: [10, 50, 100, -1],
        itemsPerPageAllText: 'Todos',
        itemsPerPageText: 'Elementos por página',
    }"
    >
    <template v-slot:[`item.enlace`]="{ item }">
        {{ item.enlace }}
    </template>
    </v-data-table>
    </v-card-text>
    </v-card>

    
</v-container>
<v-container v-else>
    <div class="d-flex justify-center">
    <v-card class="ma-5 pa-5 text-center" width="60%">
        <v-icon size="150px" color="warning">mdi-alert-circle</v-icon>
        <p style="font-family:sans-serif;">No se han cargado las ligas de Drive.<br>
        </p>
    </v-card>
    </div>
</v-container>
</template>

<script>
import { descargarLigas } from "./invitacion/invitaciones.service";

export default {
name: "drive",
components: {
    
},
props: {
    idSesion: String,
},
created() {
    this.descargar()
},
data() {
    return {
    search: '',
    headers: [], // Aquí se almacenarán los encabezados del CSV
    items: [],   // Aquí se almacenarán los datos procesados del CSV
    loading: false,
    archivoCSV: false
    };
},
methods: {
    async descargar() {
    try {
        this.loading = true;
        const serverResponse = await descargarLigas(this.idSesion); // Descarga el archivo desde el servidor
        
        // Convertir el Blob a ArrayBuffer
        const arrayBuffer = await serverResponse.arrayBuffer();
        this.loading = false;

        // Procesa el contenido del archivo como texto
        const csvText = new TextDecoder().decode(arrayBuffer); // Convierte el array a texto
        this.items = this.parseCSV(csvText); // Procesa y almacena los datos en el formato adecuado
        this.archivoCSV = true
    } catch (error) {
        this.loading = false;
        this.archivoCSV = false
        //this.$notificarError(error);
    }
    },

    parseCSV(text) {
    const rows = text.split('\n').filter(row => row.trim() !== ''); // Filtra filas vacías
    const headers = rows.shift().split(','); // Extrae los encabezados
    const parsedData = rows.map(row => {
        const data = row.split(',');
        return headers.reduce((obj, header, index) => {
        obj[header.trim()] = data[index]; // Asocia cada encabezado a su valor
        return obj;
        }, {});
    });

    // Configura los headers con text y value
    this.headers = headers.map(header => ({
        text: header.charAt(0).toUpperCase() + header.slice(1), // Capitaliza el encabezado
        value: header.trim().toLowerCase() // Formato para value (ejemplo: en minúsculas y sin espacios)
    }));

    return parsedData; // Devuelve los datos procesados
    }

},
};
</script>

<style>
.containSwitch {
width: 230px;
margin-left: 15px;
align-items: center;
}
</style>